import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CTASection() {
  return <section className="bg-brand-amber py-20" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-26">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="md:w-1/2 mb-10 md:mb-0 text-center md:text-left" data-id="element-27">
            <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-brand-navy mb-4 leading-tight" data-id="element-28">
              Ready to discuss your requirements?
            </h2>
            <p className="text-brand-navy/80 text-lg max-w-lg mx-auto md:mx-0" data-id="element-29">
              Our engineering team is standing by to specify and deliver the
              exact equipment your project needs.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="md:w-auto flex flex-col sm:flex-row gap-4" data-id="element-30">
            <a href="tel:08004647025" className="inline-flex justify-center items-center px-8 py-4 bg-brand-navy text-white font-bold rounded hover:bg-white hover:text-brand-navy transition-colors duration-300 shadow-lg" data-id="element-31">
              <Phone className="mr-2 w-5 h-5" data-id="element-32" />
              0800 464 7025
            </a>
            <Link to="/contact" className="inline-flex justify-center items-center px-8 py-4 bg-transparent border-2 border-brand-navy text-brand-navy font-bold rounded hover:bg-brand-navy hover:text-white transition-colors duration-300" data-id="element-33">
              <Mail className="mr-2 w-5 h-5" data-id="element-34" />
              Contact Form
            </Link>
          </motion.div>
        </div>
      </div>
    </section>;
}